import React from "react";
import SignupComponent from "../../components/Auth/SignupComponent";
import Layout from "../../components/Layout/Layout";

const Signup = () => {
  return (
    <>
      <Layout>
        <SignupComponent />
      </Layout>
    </>
  );
};

export default Signup;
